module.exports = __webpack_public_path__ + "img/工地主任執業證.66dad9b5.jpg";